
define('jst!calendars/tour/_step2',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Navigating. #featuretour") %></h1>\n\n<p><%= t("Use these buttons to switch between month, week and day views. #featuretour") %></p>\n');
 });

